import { render, staticRenderFns } from "./priceIndex.vue?vue&type=template&id=5cac9a8c&scoped=true"
import script from "./priceIndex.vue?vue&type=script&lang=js"
export * from "./priceIndex.vue?vue&type=script&lang=js"
import style0 from "./priceIndex.vue?vue&type=style&index=0&id=5cac9a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac9a8c",
  null
  
)

export default component.exports